import cn from 'classnames';
import { FC } from 'react';

import { BasicSkeleton } from '../BasicSkeleton/BasicSkeleton';

import styles from './SkeletonMobileRow.module.scss';

type SkeletonRowProps = {
  className?: string;
  testID?: string;
  rowsQuantity?: number;
};

export const SkeletonMobileRow: FC<SkeletonRowProps> = (props) => {
  const { className, testID, rowsQuantity = 6 } = props;

  const rowsQuantityArray: number[] = Array(rowsQuantity).fill(0);

  return (
    <div className={cn(styles.container, className)} data-testid={testID}>
      {rowsQuantityArray.map((element, index) => (
        <div className={styles.rowWrapper} key={(element + index).toString()}>
          <BasicSkeleton width="104px" height="70px" borderRadius="35px" />

          <div className={styles.innerWrapper}>
            <div className={styles.infoWrapper}>
              <BasicSkeleton width="150px" height="18px" borderRadius="23px" />

              <BasicSkeleton width="80px" height="18px" borderRadius="23px" />
            </div>

            <BasicSkeleton width="100px" height="18px" borderRadius="23px" />
          </div>
        </div>
      ))}
    </div>
  );
};
